import React from 'react';
import { LayoutGrid, List, Eye } from 'lucide-react';
import { Button } from '../ui/button';

export type LayoutMode = 'compact' | 'tooltip' | 'expanded';

interface LayoutSelectorProps {
  currentLayout: LayoutMode;
  onLayoutChange: (layout: LayoutMode) => void;
}

export const LayoutSelector: React.FC<LayoutSelectorProps> = ({
  currentLayout,
  onLayoutChange,
}) => {
  const layouts = [
    {
      id: 'compact' as LayoutMode,
      name: 'Table View',
      icon: List,
      description: 'Compact table with modal definitions'
    },
    {
      id: 'tooltip' as LayoutMode,
      name: 'Grid View',
      icon: LayoutGrid,
      description: 'Ultra-compact grid with hover tooltips'
    },
    {
      id: 'expanded' as LayoutMode,
      name: 'Card View',
      icon: Eye,
      description: 'Original expandable cards'
    }
  ];

  return (
    <div className="flex items-center gap-2 bg-gray-100 dark:bg-gray-800/50 border border-gray-300 dark:border-gray-700 rounded-lg p-1">
      {layouts.map((layout) => {
        const Icon = layout.icon;
        const isActive = currentLayout === layout.id;
        
        return (
          <Button
            key={layout.id}
            variant={isActive ? "default" : "ghost"}
            size="sm"
            onClick={() => onLayoutChange(layout.id)}
            className={`flex items-center gap-2 text-xs ${
              isActive
                ? 'bg-indigo-600 text-white hover:bg-indigo-700'
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-200 dark:hover:bg-gray-700'
            }`}
            title={layout.description}
          >
            <Icon className="h-4 w-4" />
            <span className="hidden sm:inline">{layout.name}</span>
          </Button>
        );
      })}
    </div>
  );
};